module.exports = __webpack_public_path__ + "img/ostosraha@2x.98a56f7.png";